import { openRoute as openBaseRoute } from 'src/redux/actions/routes'
import { BaseRoute, BaseSubroute } from '../../routes/BaseRoute'
import { AppRoute } from 'src/app/routes/AppRoute'
import { CatalogRoute } from 'src/catalog/routes/CatalogRoute'
import { PricingRoute } from 'src/marketing/plans/routes/PricingRoute'
// marketing routes to remove
import { BusinessRoute } from 'src/marketing/routes/BusinessRoute'

const openRoute = (subroute?: BaseSubroute) =>
  openBaseRoute(BaseRoute(subroute))

export const openLaunchPage = () => openRoute()

export const openBusinessPage = () => openRoute(AppRoute(BusinessRoute()))

export const openEditor = (cardId?: string) =>
  openRoute(AppRoute(CatalogRoute()))

export const openCatalog = () => openRoute(AppRoute(CatalogRoute()))

export const openOrder = (orderId: string) =>
  openRoute(AppRoute(CatalogRoute()))

export const openCampaignStore = (categoryId?: string) =>
  openRoute(AppRoute(CatalogRoute()))

export const openRelationshipManager = () => openRoute(AppRoute(CatalogRoute()))

export const openCampaign = (campaignId: string) =>
  openRoute(AppRoute(CatalogRoute()))

export const openPlans = () => openRoute(AppRoute(PricingRoute()))
